import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import dayjs, { Dayjs } from 'dayjs'
import 'dayjs/locale/pt-br'

interface DatePickerMultipleProps {
    value?: { data: Date }[]
    onChange?: (value: { data: Date }[]) => void
    label?: string
    disabled?: boolean
}

export function DatePickerMultiple({
    value = [],
    onChange,
    label,
    disabled = false,
}: DatePickerMultipleProps) {
    const handleDateChange = (newDate: Dayjs | null) => {
        if (!newDate || !onChange || !newDate.isValid()) return

        const dateToAdd = newDate.utc().toDate()
        const newDateFormatted = dayjs(dateToAdd).format('YYYY-MM-DD')

        // Verificar se a data já existe normalizando ambas as datas
        const dateExists = value.some(item => {
            const existingDateFormatted = dayjs
                .utc(item.data)
                .format('YYYY-MM-DD')
            return existingDateFormatted === newDateFormatted
        })

        if (!dateExists) {
            // Adicionar nova data
            onChange([...value, { data: dateToAdd }])
        } else {
            // Opcional: mostrar feedback visual que a data já existe
            console.debug('Data já selecionada:', newDateFormatted)
        }
    }

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
            <DatePicker
                label={label}
                value={null}
                onChange={handleDateChange}
                disabled={disabled}
                slotProps={{
                    textField: {
                        variant: 'filled',
                        fullWidth: true,
                        helperText:
                            value.length > 0
                                ? `${value.length} dia(s) selecionado(s)`
                                : 'Selecione as datas uma por vez',
                    },
                }}
            />
        </LocalizationProvider>
    )
}
